import BaseBookingComponent from './baseBookingComponent';

export default class Booking extends BaseBookingComponent {
    whenLoaded = Promise.all([
        customElements.whenDefined('c-calendar'),
        customElements.whenDefined('calendar-range')
    ]);

    constructor(m) {
        super(m);

        /* Binding */
        this.onComboboxDatesInput = this.onComboboxDatesInput.bind(this);
        this.setComboboxRoomsInputValue = this.setComboboxRoomsInputValue.bind(this);
        this.setHotelValue = this.setHotelValue.bind(this);

        /* UI */
        this.$comboboxRooms = this.querySelector('[data-combobox-rooms]');
        this.$comboboxDates = this.querySelector('[data-combobox-dates]');

        this.$hotelSelect = this.querySelector('[data-hotel-select]');
        this.$hotelValue = this.querySelector('[data-hotel-value]');

        this.$comboboxDatesInput = this.$comboboxDates?.querySelector('[data-combobox-input]');
        this.$comboboxDatesDialog = this.$comboboxDates?.querySelector('[data-combobox-dialog]');
        this.$comboboxDatesCta = this.$comboboxDates?.querySelector('[data-combobox-cta]');

        this.$comboboxRoomsInput = this.$comboboxRooms?.querySelector('[data-combobox-input]');
        this.$comboboxRoomsDialog = this.$comboboxRooms?.querySelector('[data-combobox-dialog]');
        this.$comboboxRoomsCta = this.$comboboxRooms?.querySelector('[data-combobox-cta]');
        this.$adultsInputNumber = this.querySelector('[data-adults-number] input');
        this.$childrenInputNumber = this.querySelector('[data-children-number] input');
    }

    // =============================================================================
    // BaseBookingComponent
    // =============================================================================

    getCheckInDateField() {
        return 'widget-dates[check-in]';
    }

    getCheckOutDateField() {
        return 'widget-dates[check-out]';
    }

    getPropertyField() {
        return 'widget-property';
    }

    appendRoomDataToUrl(url, data) {
        const adults = data.get('widget-guests[room-1][adults]');
        const children = data.get('widget-guests[room-1][children]');

        if (adults) url.searchParams.append('adults', adults);
        if (children) url.searchParams.append('children', children);
    }

    // =============================================================================
    // Lifecycle
    // =============================================================================
    connectedCallback() {
        super.connectedCallback();

        this.whenLoaded.then(() => {
            requestAnimationFrame(() => {
                this.onReset();
            });
        });
    }

    disconnectedCallback() {
        super.disconnectedCallback();
    }

    // =============================================================================
    // Events
    // =============================================================================
    bindEvents() {
        this.$comboboxDatesInput.addEventListener('change', this.onComboboxDatesInput);
        this.$adultsInputNumber.addEventListener('change', this.setComboboxRoomsInputValue);
        this.$childrenInputNumber.addEventListener('change', this.setComboboxRoomsInputValue);
        this.$hotelSelect.addEventListener('change', this.setHotelValue);
    }

    unbindEvents() {
        this.$comboboxDatesInput.removeEventListener('change', this.onComboboxDatesInput);
        this.$adultsInputNumber.addEventListener('change', this.setComboboxRoomsInputValue);
        this.$childrenInputNumber.addEventListener('change', this.setComboboxRoomsInputValue);
        this.$hotelSelect.addEventListener('change', this.setHotelValue);
    }

    // =============================================================================
    // Callbacks
    // =============================================================================
    onCalendarChange(e) {
        this.$comboboxDatesInput.value = this.formatDateRange(e.target.value);
        this.$comboboxDates.close();
    }

    onCalendarError(e) {
        this.$comboboxDates.open();
    }

    onComboboxDatesInput(e) {
        if (this.isValidISO8601Range(e.target.value)) {
            this.$calendar.value = e.target.value;
        } else {
            this.$comboboxDatesInput.value = '';
            this.$calendar.value = '';

            requestAnimationFrame(() => {
                this.showCalendarError();
            });
        }
    }

    onReset() {
        this.setComboboxDatesInputValue();
        this.setComboboxRoomsInputValue();
        this.setHotelValue();
    }

    // =============================================================================
    // Methods
    // =============================================================================
    setComboboxDatesInputValue() {
        if (!this.$calendar) {
            return;
        }
        this.$comboboxDatesInput.value = this.formatDateRange(this.$calendar?.value);
    }

    setComboboxRoomsInputValue() {
        let stringValue = '';

        const total =
            parseInt(this.$adultsInputNumber.value) + parseInt(this.$childrenInputNumber.value);
        stringValue += total;
        stringValue += total === 1 ? ' guest' : ' guests';

        this.$comboboxRoomsInput.value = stringValue;
    }

    setHotelValue(e) {
        const selectedOption = this.$hotelSelect.options[this.$hotelSelect.selectedIndex];
        this.$hotelValue.innerHTML = selectedOption.textContent;
    }
}
